<template>
  <div class="ba-content-main ba-w-100">

    <!-- Step 1 -->
    <div v-if="step.step == 1" class="default-border ba-pd-1 ba-flex ba-f-column ba-gp-1">
      <span class="ba-color-black23 font-16">{{t.talk_to_support}}</span>
      <span class="ba-color-black13 font-14">{{t.label_getting_results}}<br>{{t.label_contact_support}}</span>
      <a class='ba-btn ba-md ba-blue ba-w-30' :href="this.view.handler_routes.rota_office_support_system_home" target="_blank">
        <builderall-icon code='2b77'></builderall-icon>
        {{ t.ush_support }}
      </a>
    </div>

    <!-- Step 2 -->
    <div v-if="step.step == 2" class="ba-flex ba-gp-1">
      <div v-if="IsEmpty(view.user_data.pause_account)" class="default-border ba-pd-1 ba-flex ba-f-column ba-gp-1">
        <span class="ba-color-black23 font-16">{{t.pause_your_account}}</span>
        <span class="ba-color-black13 font-14">{{t.label_keep_your_account}}</span>
        <button class='ba-btn ba-md ba-blue' @click="pauseAccount">
          {{t.pause_account}}
        </button>
      </div>

      <div class="default-border ba-pd-1 ba-flex ba-f-column ba-gp-1">
        <span class="ba-color-black23 font-16">{{t.label_different_plan}}</span>
        <span class="ba-color-black13 font-14">{{t.label_unhappy_with_your_plan}}</span>
        <a class='ba-btn ba-md ba-blue' :class="{'ba-w-40': !IsEmpty(view.user_data.pause_account)}" href="https://checkout.builderall.com/plans" target="_blank">
          {{ t.change_plan }}
        </a>
      </div>
    </div>

    <!-- Step 3 -->
    <div v-if="step.step == 3" v-for="question in questions" class="ba-flex ba-gp-1 ba-f-column">
      <p v-for="answer in question.answers" :class="['questions', isChecked(answer.id) ? 'checked' : '' ]">
        <label class="container">
          <span v-if="!IsEmpty(answer.description[view.user_data.pais])">{{ answer.description[view.user_data.pais] }}</span>
          <span v-else>{{ answer.description['us'] }}</span>
          <input type="radio" id="checkedCategories" name="checkedCategories[]" v-model="checkedCategories" :value="answer">
          <span class="checkmark" />
        </label>
        <textarea
          v-if="answer.answer_type == 'TEXT'"
          v-model="answer.answer"
          class='ba-textarea text-input'
          :rows='answer.input_rows'
          :placeholder='getPlaceholder(answer.input_placeholder)'
        ></textarea>
      </p>
    </div>

    <!-- Pause Confirm -->
    <div v-if="step.step == 5" class="default-border ba-pd-1 ba-flex ba-f-column ba-gp-1">
      <span class="ba-color-black13 font-14" v-html="t.label_pause_description">
        <br>{{t.ready_hit_pause}}</span>
    </div>

    <!-- Pause Confirm -->
    <div v-if="step.step == 6" class="default-border ba-pd-1 ba-flex ba-f-column ba-gp-1">
      <span class="ba-color-black13 font-14">{{t.label_your_subscription}}
        <br>{{t.label_order_to_pause}}
        <br>{{t.label_continue_proceed}}.</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "pause-body",
  props: ['t', 'step', 'questions', 'view', 'setQuestions', 'pause'],
  data() {
    return {
      checkedCategories: [],
    }
  },
  methods: {
    isChecked(id) {
      return this.checkedCategories.id == id
    },
    pauseAccount() {
      this.pause('pause_account')
    },
    IsEmpty(val) {
      return isEmpty(val)
    },
    getPlaceholder(value) {
      return this.IsEmpty(value[this.view.user_data.pais]) ? value['us'] : value[this.view.user_data.pais];
    }
  },
  watch: {
    checkedCategories(newVal) {
      this.setQuestions(newVal)
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: block;
  position: relative;
  padding: 12px 16px 12px 48px;
  margin: 0;
  cursor: pointer;

  color: #111827;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 26%;
  left: 16px;
  height: 20px;
  width: 20px;
  background-color: transparent;

  border-radius: 50%;
  border: 1px solid #B4C4D7;
}

.container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.questions {
  border-radius: 6px;
  border: 1px solid #E4EAF6;
  background: #FCFEFF;
  margin: 0;
  &.checked {
    border: 1px solid #2196F3;
  }
}
.text-input {
  width: calc(100% - 40px);
  margin: 0 20px 12px;
}
.ba-w-40 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/pause-account/body.vue